<div class="ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="group-content">
      <div class="info-content--top">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="hypersoft-user-multi.svg"></div>
        </div>
        <div class="orderMode-info-wrapper">
          <div class="group-info-item title-margin">
            <h2 langkey="phRemoteOrder_DefineName_Title"></h2>
          </div>
        </div>
      </div>
      <div class="name-form__list">
        <div class="group-info-item form-input_content">
          <p class="text" langkey="phRemoteOrder_DefineUserName_Info">
          </p>
        </div>
        <!-- User name-->
        <div class=" input-content">
          <div class="ya-input-container">
            <div class="ya-input-wrapper">
              <input type="text" class="ya-input-text textsize" (blur)="setWebView()"
                [placeholder]="userNameInputPlaceholder" [formControl]="userNameInputFormControl">
              <ng-container *ngIf="userNameInputFormControl.touched && userNameInputFormControl.invalid">
                <ng-container
                  *ngIf="userNameInputFormControl.errors && activeError(userNameInputFormControl, field.UserName)">
                  <ya-errorvalidation [controlValidation]="true"
                    [errorMessage]="activeError(userNameInputFormControl, field.UserName)"></ya-errorvalidation>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="group-info-item form-input_content">
          <p class="text" langkey="phRemoteOrder_DefineGroupName_Info">
          </p>
        </div>
        <!-- Group name-->
        <div class="input-content">
          <div class="ya-input-container">
            <div class="ya-input-wrapper">
              <input type="text" class="ya-input-text textsize" (blur)="setWebView()"
                [placeholder]="groupNameInputPlaceholder" [formControl]="groupNameInputFormControl">
              <ng-container *ngIf="groupNameInputFormControl.touched && groupNameInputFormControl.invalid">
                <ng-container
                  *ngIf="groupNameInputFormControl.errors && activeError(groupNameInputFormControl, field.GroupName)">
                  <ya-errorvalidation [controlValidation]="true"
                    [errorMessage]="activeError(groupNameInputFormControl, field.GroupName)"></ya-errorvalidation>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <div class="botton-wrapper">
        <div class="ya-webshop-button-container">
          <ng-container *ngIf="setButtonActive() then activeButton else deactiveButton">
          </ng-container>
          <ng-template #activeButton>
            <button mat-flat-button type="submit" (click)="CreateGroupAndNavigate()">
              <span langkey="phGlobal_Continue"></span></button>
          </ng-template>
          <ng-template #deactiveButton>
            <button mat-flat-button disabled><span langkey="phGlobal_Continue"></span></button>
          </ng-template>
        </div>
      </div>
    </div>
  </div>